import gqlRequest from 'graphql/generic';

/**
 * Load all user preferences in a single GraphQL query.
 * Returns aliased preference values keyed by the alias name.
 *
 * IMPORTANT — opaque string handling:
 * Every preference value is stored as a JSON-encoded string on the backend.
 * Callers MUST parse the result with `JSON.parse(value)` to recover the
 * original type (object, array, boolean, etc.).  A null return means no
 * preference has been set for that key yet.
 *
 * Example:
 *   const prefs = await loadUserPreferences();
 *   const ordersView = JSON.parse(prefs.ordersView || '{}');
 */

export const loadUserPreferences = async () => {
  return gqlRequest(`
    query LoadUserPreferences {
      selectedAgencyId: getPreference(key: "selectedAgencyId")
      ordersView: getPreference(key: "ordersView")
      orderColumns: getPreference(key: "orderColumns")
      recentOrders: getPreference(key: "recentOrders")
      orderMenuCollapsed: getPreference(key: "orderMenuCollapsed")
      assistantFullscreen: getPreference(key: "assistantFullscreen")
      language: getPreference(key: "language")
      theme: getPreference(key: "theme")
    }
  `);
};

export default { loadUserPreferences };
